import { render, staticRenderFns } from "./commodityMall.vue?vue&type=template&id=78d46c18&scoped=true&"
import script from "./commodityMall.vue?vue&type=script&lang=js&"
export * from "./commodityMall.vue?vue&type=script&lang=js&"
import style0 from "./commodityMall.vue?vue&type=style&index=0&id=78d46c18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d46c18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78d46c18')) {
      api.createRecord('78d46c18', component.options)
    } else {
      api.reload('78d46c18', component.options)
    }
    module.hot.accept("./commodityMall.vue?vue&type=template&id=78d46c18&scoped=true&", function () {
      api.rerender('78d46c18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/commodityMall.vue"
export default component.exports